module.exports = __webpack_public_path__ + "img/MultiTrust.a120d637.png";